import Grid2 from "@mui/material/Unstable_Grid2";
import Table from "../../../components/table/Table";
import DomesticMarketTopPriceChangesForm from "./DomesticMarketTopPriceChangesForm";
import { faCols_domesticMarketTopPriceChanges } from "../../../components/tableHeaderNames/HeaderName";
import { useDomesticMarketTopPriceChangesContext } from "../../../context/domestic-market/DomesticMarketTopPriceChangesContext";
import MarketChart from "../../market-watch/MarketChart";

const DomesticMarketTopPriceChanges = () => {
  const { tableData } = useDomesticMarketTopPriceChangesContext();

  return (
    <Grid2 container>
      <Grid2 xs={12}>
        <Table
          tableData={tableData}
          isActions={true}
          Chart={MarketChart}
          height="88vh"
          faCols={faCols_domesticMarketTopPriceChanges}
          tableTitle={{
            title: "بیشترین تغییرات قیمتی کالا",
            desc: "متن آزمایشی",
          }}
          Form={DomesticMarketTopPriceChangesForm}
        />
      </Grid2>
    </Grid2>
  );
};

export default DomesticMarketTopPriceChanges;
